module.exports = __webpack_public_path__ + "static/media/book.88436e64.jpg";